import React from 'react'
import { Input } from '@enterprise-ui/canvas-ui-react'

interface IMakeAssetPrivatePublic {
  index?: number
  makeAssetPublic: any
  assetPublic: boolean
}
const AssetPublicPrivate = (props: IMakeAssetPrivatePublic) => {
  const { index, makeAssetPublic, assetPublic } = props

  const PublicPrivateAssetOptions = [
    {
      label: 'Public asset (all Gallery users can access)',
      value: 'Public',
    },
    {
      label: 'Private asset (only users with permission can access)',
      value: 'Private',
    },
  ]

  return (
    <>
      <Input.Label className="bold-asset-text">Asset permissions</Input.Label>
      <Input.Radio
        key={`new-asset-file-permissions-${index}`}
        id={`new-asset-file-permissions-${index}`}
        data-testid="new-asset-permissions"
        value={assetPublic ? 'Public' : 'Private'}
        onUpdate={(id: any, value: any) => {
          makeAssetPublic(value === 'Public')
        }}
        options={PublicPrivateAssetOptions}
      />
    </>
  )
}

export default AssetPublicPrivate
